import React, { useState, useEffect } from "react";
import styled from "styled-components";
import AddExcessForm from "components/widgets/forms/setup/Add_Excess";
import { fetch_product_details, test_product_excess } from "services/apiSrv";
import Loader from "components/widgets/loader";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Card, Typography, Avatar, Button, Tabs, message, InputNumber, Select } from 'antd';
import * as Icon from 'react-feather';

const { Option } = Select;

// === Styled Components ===
const Container = styled.div`
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  background: #f8fafc;
  min-height: 100vh;
`;

const HeaderCard = styled(Card)`
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  border: none;
  margin-bottom: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  .ant-card-body { padding: 32px; }
`;

const ProductTitle = styled(Typography.Title)`
  &&& { color: white !important; margin: 0; font-size: 32px; }
`;

const ProductDesc = styled.div`
  color: rgba(255,255,255,0.9);
  font-size: 16px;
  max-width: 600px;
  margin-top: 8px;
`;

const SectionTitle = styled(Typography.Title)`
  &&& {
    font-size: 22px;
    color: #1a1a1a;
    margin-bottom: 24px;
    border-bottom: 3px solid #1890ff;
    padding-bottom: 8px;
    display: inline-block;
  }
`;

// Preview Section Styles
const PreviewCard = styled(Card)`
  border-radius: 16px;
  border: none;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  margin: 32px 0;
  background: #ffffff;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin: 24px 0;
`;

const InfoItem = styled.div`
  background: #f8fafc;
  padding: 18px;
  border-radius: 12px;
  border-left: 5px solid #4f46e5;
  text-align: center;
`;

const InfoLabel = styled.div`
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
`;

const InfoValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px;
  margin-top: 16px;
`;

const Th = styled.th`
  text-align: left;
  padding: 16px;
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
  font-size: 14px;
  border-radius: ${props => props.first ? "12px 0 0 12px" : props.last ? "0 12px 12px 0" : "0"};
`;

const Td = styled.td`
  padding: 16px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  &:first-child { border-left: 1px solid #e2e8f0; border-radius: 12px 0 0 12px; }
  &:last-child { border-right: 1px solid #e2e8f0; border-radius: 0 12px 12px 0; }
`;

const CalculatorBox = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 32px;
  color: white;
  margin: 32px 0;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  text-align: center;
`;

const ResultValue = styled.div`
  font-size: 42px;
  font-weight: 800;
  margin: 20px 0;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
`;

export default function ExcessLiabilityConfig() {
  const { id: productSystemRef } = useParams();

  const [basePremium, setBasePremium] = useState(80000);
  const [selectedOption, setSelectedOption] = useState(null);
  const [calculatedExcess, setCalculatedExcess] = useState(0);
  const [excessLogic, setExcessLogic] = useState("");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['productDetails', productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
  });

  const [productExcessState, setProductExcessState] = useState(null);

  useEffect(() => {
    if (data?.data?.[0]?.excessConfig) {
      setProductExcessState(data.data[0].excessConfig);
    }
  }, [data]);

  const handleTestCalculation = async () => {
    if (!basePremium || basePremium <= 0) {
      message.error("Please enter a valid base premium");
      return;
    }

    if (!productExcessState) {
      message.warning("No excess configuration loaded");
      return;
    }

    let excess = 0;
    const standard = productExcessState.standard;

    // Standard excess
    if (standard.rate.rateType === "percentage") {
      excess = basePremium * standard.rate.rateValue;
    } else {
      excess = standard.rate.rateValue;
    }

    // Apply selected option
    if (selectedOption !== null && productExcessState.options[selectedOption]) {
      const opt = productExcessState.options[selectedOption];
      excess = opt.type === "percentage" ? basePremium * opt.value : opt.value;
    }

    // Apply min/max
    if (standard.minimum && excess < standard.minimum) excess = standard.minimum;
    if (standard.maximum && excess > standard.maximum) excess = standard.maximum;

    // setCalculatedExcess(excess);

    try {
      const payload = {
        productSystemRef,
        basePremium: Number(basePremium),
        excessOptionIndex: selectedOption
      };
     const res = await test_product_excess(payload);
     setCalculatedExcess(res?.data?.premium?.excessPremium)
     setExcessLogic(res?.data?.ExcessCalculationLogic?.[0])
     console.log("RES calcu", res?.data?.ExcessCalculationLogic?.[0])
      message.success("Excess calculated & tested successfully!");
    } catch (err) {
      message.error("Test failed");
    }
  };

  if (isLoading) return <Loader />;
  if (!data?.data?.[0]) return <div>No product found</div>;

  const product = data.data[0];
  console.log("single proeuct", product)

  return (
    <Container>
      <HeaderCard>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
          <Avatar size={110} style={{ backgroundColor: 'rgba(255,255,255,0.2)', fontSize: 40, fontWeight: 'bold' }}>
            {product.productName?.slice(0, 2).toUpperCase()}
          </Avatar>
          <div>
            <ProductTitle level={2}>{product.productName}</ProductTitle>
            <ProductDesc>{product.productDescription || "Comprehensive insurance with customizable excess structure"}</ProductDesc>
          </div>
        </div>
      </HeaderCard>

      <Tabs defaultActiveKey="1" type="card" size="large">
        <Tabs.TabPane tab="Compulsory Excess Configuration" key="1">
          {/* === EDIT FORM === */}
          <Card style={{ borderRadius: 16, boxShadow: '0 8px 25px rgba(0,0,0,0.1)', marginBottom: 32 }}>
            <SectionTitle level={3}>Edit Excess Configuration</SectionTitle>
            <AddExcessForm
              excessConfig={productExcessState}
              onConfigChange={setProductExcessState}
              refetchProductDetails={refetch}
            />
          </Card>

          {/* === LIVE CONFIGURATION PREVIEW (READ-ONLY) === */}
          {productExcessState && (
            <PreviewCard title={<SectionTitle level={3}>Current Excess Configuration</SectionTitle>} bordered={false}>
              {/* Standard Excess */}
              <div style={{ marginBottom: 32 }}>
                <h4>Standard Excess</h4>
                <InfoGrid>
                  <InfoItem>
                    <InfoLabel>Rate Type</InfoLabel>
                    <InfoValue>
                      {productExcessState.standard.rate.rateType === "percentage" ? "Percentage" : "Fixed Amount"}
                    </InfoValue>
                  </InfoItem>
                  <InfoItem>
                    <InfoLabel>Rate Value</InfoLabel>
                    <InfoValue>
                      {productExcessState.standard.rate.rateType === "percentage"
                        ? `${(productExcessState.standard.rate.rateValue).toFixed(1)}%`
                        : `KES ${productExcessState.standard.rate.rateValue.toLocaleString()}`}
                    </InfoValue>
                  </InfoItem>
                  <InfoItem>
                    <InfoLabel>Minimum</InfoLabel>
                    <InfoValue>KES {productExcessState.standard.minimum?.toLocaleString()}</InfoValue>
                  </InfoItem>
                  <InfoItem>
                    <InfoLabel>Maximum</InfoLabel>
                    <InfoValue>
                      {productExcessState.standard.maximum ? `KES ${productExcessState.standard.maximum.toLocaleString()}` : "No limit"}
                    </InfoValue>
                  </InfoItem>
                </InfoGrid>
              </div>

              {/* Customer Options */}
              {productExcessState.options?.length > 0 && (
                <div style={{ marginBottom: 32 }}>
                  <h4>Voluntary Excess Options</h4>
                  <Table>
                    <thead>
                      <tr>
                        <Th first>Label</Th>
                        <Th>Type</Th>
                        <Th last>Value</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {productExcessState.options.map((opt, i) => (
                        <tr key={i}>
                          <Td><strong>{opt.label}</strong></Td>
                          <Td>{productExcessState?.standard.rate.rateType  === "percentage" ? "Percentage" : "Fixed"}</Td>
                          <Td>
                            {productExcessState.standard.rate.rateType === "percentage"
                              ? `${(opt.value)}% of premium`
                              : `KES ${opt.value.toLocaleString()}`}
                          </Td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}

              {/* Additional Rules */}
              {productExcessState.additionalRules?.length > 0 && (
                <div>
                  <h4>Additional Excess Rules</h4>
                  <Table>
                    <thead>
                      <tr>
                        <Th first style={{ width: '70%' }}>Condition</Th>
                        <Th last>Extra Excess</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {productExcessState.additionalRules.map((rule, i) => (
                        <tr key={i}>
                          <Td>{rule.condition}</Td>
                          <Td><strong>{(rule.additionalExcessPercent * 100).toFixed(1)}%</strong></Td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </PreviewCard>
          )}

          {/* === EXCESS CALCULATOR === */}
          <CalculatorBox>
            <h2 style={{ fontSize: 28, marginBottom: 24 }}>Test Excess Calculator</h2>

            <div style={{ maxWidth: 500, margin: '0 auto' }}>
              <div style={{ marginBottom: 20 }}>
                <label>Base Premium (KES)</label>
                <InputNumber
                  style={{ width: '100%', height: 56, fontSize: 18, borderRadius: 12 }}
                  value={basePremium}
                  onChange={setBasePremium}
                  min={1000}
                  step={5000}
                  formatter={v => `KES ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={v => v.replace(/KES\s?|(,*)/g, '')}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label>Choose Excess Option</label>
                <Select
                  style={{ width: '100%' }}
                  size="large"
                  placeholder="Use standard rate"
                  value={selectedOption}
                  onChange={setSelectedOption}
                  allowClear
                >
                  {productExcessState?.options?.map((opt, i) => (
                    <Option key={i} value={i}>
                      {opt.label} → {opt.type === "percentage" ? `${(opt.value * 100).toFixed(1)}%` : `KES ${opt.value.toLocaleString()}`}
                    </Option>
                  ))}
                </Select>
              </div>

              <Button
                type="primary"
                size="large"
                block
                style={{ height: 56, fontSize: 18, marginTop: 20, borderRadius: 12 }}
                onClick={handleTestCalculation}
              >
                Calculate Excess
              </Button>
              

              {calculatedExcess <= 0 && (
                <div style={{ marginTop: 30, padding: '24px', background: 'rgba(255,255,255,0.15)', borderRadius: 16, backdropFilter: 'blur(10px)' }}>
                  <div style={{ fontSize: 18, opacity: 0.9 }}>Final Calculated Excess</div>
                  <ResultValue>KES {calculatedExcess.toLocaleString()}</ResultValue>
                  <div style={{ opacity: 0.8 }}>
                    {selectedOption !== null ? "Custom option applied" : "Standard rate applied"}
                  </div>
                  {excessLogic && (<div>{excessLogic}</div>)}
                </div>
              )}
            </div>
          </CalculatorBox>
        </Tabs.TabPane>
      </Tabs>
    </Container>
  );
}